'use client';
import { IconClose, IconCloseThick } from '@wanteddev/wds-icon';
import { jsx } from 'react/jsx-runtime';

// src/components/modal/helpers.tsx
var getDefaultCloseIcon = (variant) => {
  switch (variant) {
    case "floating":
      return /* @__PURE__ */ jsx(IconCloseThick, {});
    default:
      return /* @__PURE__ */ jsx(IconClose, {});
  }
};

export { getDefaultCloseIcon };
